/* eslint-disable jsx-a11y/alt-text */
import { Typography } from "@mui/material";
import HostBenefitsCard from "../card/host-benefits-card";
import { hostBenefitsData } from "../../assets/data/all-data";

const HostBenefit = () => {
  return (
    <section id="hostbenefits">
      <div
        style={{
          marginTop: 75,
          marginBottom: 50,
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography variant="h3" style={{ textAlign: "center" }}>
          Host Benefits
        </Typography>
        <HostBenefitsCard hostBenefitsData={hostBenefitsData} />
      </div>
    </section>
  );
};

export default HostBenefit;
